import React from "react";
export default function ChatWindow({messages = []}) {
    return (<div className="card shadow-sm mb-3">

        <div
            className="card-header bg-primary text-white"
        >
            🤖 DrHiS AI Receptionist
        </div>

        <div
            className="card-body"
            style={{
                background: "#f8f9fa"
            }}
        >

            {messages.map((msg, index) => (<div
                key={index}
                className={msg.sender === "bot" ? "text-start mb-3" : "text-end mb-3"}
            >

                <div
                    style={{
                        display: "inline-block",
                        maxWidth: "80%",
                        padding: "12px 16px",
                        borderRadius: "18px",
                        whiteSpace: "pre-wrap",
                        background: msg.sender === "bot" ? "#e9ecef" : "#0d6efd",
                        color: msg.sender === "bot" ? "#000" : "#fff"
                    }}
                >

                    <div
                        style={{
                            fontWeight: "bold", marginBottom: 5
                        }}
                    >
                        {msg.sender === "bot" ? "🤖 AI Receptionist" : "🧑 Patient"}
                    </div>

                    {msg.text}

                </div>

            </div>))}

        </div>

    </div>);
}